import { Alert, Box, CircularProgress, Stack, Typography } from '@mui/material';

import DataList from '../../../form/DataList';
import Select from '../../../form/Select';
import { ORIGEM_MERCADORIA_OPTIONS } from '../../../../constants/fiscal';

function FiscalTabPanel({ module, dados }) {
    const { perfisFiscais, perfilSelecionado, perfilFiscalTexto, carregando } = module.state;

    const { alterarCampoFiscal, alterarPerfilFiscal } = module.actions;

    const possuiPerfilFiscal = Boolean(dados?.fiscalPerfilId);

    return (
        <Stack spacing={2}>
            <Typography variant="subtitle1">Configuração fiscal do produto</Typography>

            <Box
                sx={{
                    display: 'flex',
                    gap: 2,
                    flexWrap: 'wrap',
                    alignItems: 'flex-end',
                }}
            >
                <DataList
                    text="Perfil fiscal"
                    title="Perfil fiscal utilizado para determinar as regras tributárias do produto"
                    name="FiscalPerfil.descricao"
                    filteredOptions={perfisFiscais}
                    handleOnChange={alterarPerfilFiscal}
                    value={perfilFiscalTexto?.descricao || ''}
                    inputWidth="420px"
                    disabled={carregando && perfisFiscais.length === 0}
                />

                <Select
                    text="Origem da mercadoria"
                    title="Código de origem da mercadoria utilizado na emissão fiscal"
                    name="origemMercadoria"
                    options={ORIGEM_MERCADORIA_OPTIONS}
                    handleOnChange={alterarCampoFiscal}
                    value={dados?.origemMercadoria ?? ''}
                    notOptNull={false}
                    inputWidth="480px"
                    required={possuiPerfilFiscal}
                />

                {carregando && <CircularProgress size={24} />}
            </Box>

            {!possuiPerfilFiscal && (
                <Alert severity="info">
                    O produto ainda não possui perfil fiscal. A origem poderá ser preenchida isoladamente para aproveitamento
                    futuro da entrada de XML.
                </Alert>
            )}

            {possuiPerfilFiscal && !dados?.origemMercadoria && (
                <Alert severity="warning">A origem da mercadoria é obrigatória quando o produto possui um perfil fiscal.</Alert>
            )}

            {perfilSelecionado?.perfilAtual && (
                <Alert severity="warning">
                    O perfil atualmente vinculado não está mais disponível para novos vínculos. Ele foi mantido visível para
                    evitar alteração automática do cadastro.
                </Alert>
            )}

            {perfilSelecionado && !perfilSelecionado.perfilAtual && (
                <Alert severity="success">Perfil selecionado: {perfilSelecionado.descricao}</Alert>
            )}
        </Stack>
    );
}

export default FiscalTabPanel;
